var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',_vm._b({ref:"vProvider",staticClass:"validateAlert",attrs:{"mode":_vm.modelType},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_vm._t("default",null,{"errors":errors})]}}],null,true)},'ValidationProvider',_vm.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }